import React, { useRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import icons from '../../icons';
import Pill from './Pill';
import Status from './Status';

const Overlay = ({ visible, item }) => {
    const [overlayPos, setOverlayPos] = useState({});
    const overlayRef = useRef<HTMLDivElement>(null);
    const overlayClass = classNames({
        sl__item__overlay: true,
        sl__item__overlay__visible: visible
    });

    useEffect(() => {
        if (overlayRef && overlayRef.current && visible) {
            const pos = overlayRef.current.getBoundingClientRect();
            const height = pos.height + pos.top;
            const winHeight = window.innerHeight;

            if (height < winHeight) {
                setOverlayPos({ top: 0 });
            }
            if (height > winHeight) {
                setOverlayPos({ bottom: 0 });
            }
        }
        if (!visible) {
            setOverlayPos(null);
        }
    }, [visible]);

    return (
        <div ref={overlayRef} className={overlayClass} style={overlayPos}>
            <div className="sl__item__overlay__row">
                <div className="sl__item__icon__row__detail">
                    <div className="sl__item__recipientName">
                        {item.primary_contact_name}
                    </div>
                    <Status label={item.status} expired={item.is_expired} />
                </div>
            </div>
            <div className="sl__item__overlay__row">
                <div className="sl__item__overlay__message">
                    <div className="sl__item__overlay__msg_icon">
                        {icons.slDetails}
                    </div>
                    {item.list_name}
                </div>
                {((item.total_eligible !== null) || (item.total_subscribers !== null)) &&
                    <div className="sl__item__pills__row">
                        {(item.total_eligible !== null) &&
                            <Pill color="green" label={`${item.total_eligible} Eligible`} />
                        }
                        {(item.total_subscribers !== null) &&
                            <Pill color="blue" label={`${item.total_subscribers} Subs`} />
                        }
                    </div>
                }
            </div>
            <div className="sl__item__overlay__row">
                <div className="sl__item__icon__row">
                    <div className="sl__item__icon__row__icon">{icons.home}</div>
                    <div className="sl__item__icon__row__detail">{item.outlet_name}</div>
                </div>
                <div className="sl__item__icon__row">
                    <div className="sl__item__icon__row__icon">{icons.contact}</div>
                    <div className="sl__item__icon__row__detail">{item.assigned_to || 'Unassigned'}</div>
                </div>
            </div>
            <div className="sl__item__overlay__row">
                <div className="sl__item__icon__row">
                    <div className="sl__item__icon__row__icon">{icons.time}</div>
                    <div className="sl__item__icon__row__detail">{item.last_activity}</div>
                </div>
            </div>
        </div>
    );
};

Overlay.defaultProps = {
    visible: false,
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/sections/SmartList/Overlay.tsx